export const popupAction = (node, options) => {  
    $(node).popover({
        placement : 'bottom',
        trigger : 'hover'
    });
    $(node).confirmation(options)
 }